import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-other-experiences',
  templateUrl: './other-experiences.component.html',
  styleUrls: ['./other-experiences.component.scss']
})
export class OtherExperiencesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
